import { render, staticRenderFns } from "./bindOrgan.vue?vue&type=template&id=7b462606&scoped=true&"
import script from "./bindOrgan.vue?vue&type=script&lang=js&"
export * from "./bindOrgan.vue?vue&type=script&lang=js&"
import style0 from "./bindOrgan.vue?vue&type=style&index=0&id=7b462606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b462606",
  null
  
)

export default component.exports